module.exports = __webpack_public_path__ + "static/media/twelveth_miller_house9.30cadeb3.png";